/* Scoped, event-driven enhancement. Native scrolling works without JavaScript. */
if (!customElements.get('ss-swipe-nav')) {
  customElements.define('ss-swipe-nav', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.ss-qn');
      this.left = this.querySelector('.ss-qn-edge--left');
      this.right = this.querySelector('.ss-qn-edge--right');
      if (!this.track || this.abort) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.update = () => {
        const links = this.track.querySelectorAll('a');
        if (!links.length) return;
        const bounds = this.track.getBoundingClientRect();
        const rects = Array.from(links, link => link.getBoundingClientRect());
        this.left.hidden = Math.min(...rects.map(r => r.left)) >= bounds.left - 1;
        this.right.hidden = Math.max(...rects.map(r => r.right)) <= bounds.right + 1;
      };
      const move = direction => this.track.scrollBy({ left: direction * this.track.clientWidth * .7, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      this.left.addEventListener('click', () => move(-1), options);
      this.right.addEventListener('click', () => move(1), options);
      this.track.addEventListener('scroll', this.update, { ...options, passive: true });
      this.track.addEventListener('focusin', event => {
        if (event.target.matches('a')) event.target.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      }, options);
      this.observer = new ResizeObserver(this.update);
      this.observer.observe(this.track);
      this.update();
      document.fonts.ready.then(() => { if (this.isConnected) this.update(); });
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.abort = null;
      this.observer?.disconnect();
    }
  });
}
